// src/utils/file.js

/**
 * Convert a File object to a Base64-encoded string (without data: prefix).
 * @param {File} file - The file to convert.
 * @returns {Promise<string>} Resolves to the Base64 string.
 */
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result; // "data:<mime>;base64,XXXXXXXX"
        const base64 = dataUrl.split(',')[1];
        resolve(base64);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }
  